module.exports = __webpack_public_path__ + "img/arrow-filter.d30a47c3.svg";